import { createAction } from '@reduxjs/toolkit';

export default createAction<any>('performDeliveryEstimate');
